{
	"backToStartPage": "Zurück zur Startseite",
	"transactionDetailsTitle": "Transaktions details",
	"btnVerifyTransactions": "Transaktionen verifizieren",
	"kpi": {
		"date": "Datum",
		"quantity": "Menge",
		"carbonReductions": "Kohlenstoffreduzierungen"
	},
	"verifyTransactionModal": {
		"title": "Transaktion verifizieren",
		"description": "Bitte geben Sie die Datensatz-ID für diese Transaktion ein. Sie finden die Informationen in der Erklärung.",
		"recordIdLabel": "Datensatz-ID",
		"cancelTitle": "Abbrechen",
		"verifyTitle": "Verifizieren",
		"errors": {
			"recordIdRequired": "Datensatz-ID ist erforderlich",
			"recordIdInvalid": "Record ID must be 16 characters (letters or numbers), formatted like ABCD 1234 EFGH 5678",
			"verificationFailed": "Die Transaktion konnte nicht verifiziert werden. Bitte überprüfen Sie die Datensatz-ID"
		}
	},
	"errors": {
		"notFound": "Transaktion nicht gefunden"
	}
}
